import React, { Component } from "react";
import { profile, readJson, GET, alert, loading } from "./CustomComponent.js";
import { Navbar, Nav } from "react-bootstrap";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      array_link: [],
      user_profile: profile,
      menu_list: readJson("menu_list") || global.menu
    };
  }

  componentDidMount = async () => {
    this.toggleCreate(false);
    const { user_profile } = this.state;
    if (!user_profile) {
      window.location.href = "/";
      return;
    }
    // โหลด profile และเมนูกิจกรรมพร้อมกัน (ขนาน) เพื่อความเร็ว แล้วค่อยคำนวณเมนูครั้งเดียว
    const [profileData, menu_list] = await Promise.all([
      this.GetProfile(),
      this.GetActivity(),
    ]);
    this.setState({
      user_profile: profileData,
      menu_list,
      array_link: this.filterMenu(menu_list, profileData),
    });
  };

  // ซ่อน/แสดงปุ่ม ".create" ของหน้าปัจจุบันตามสิทธิ์
  toggleCreate = (show) => {
    const el = document.getElementsByClassName(
      window.location.pathname.replaceAll("/", "") + ".create",
    )[0];
    if (el) el.classList.toggle("d-none", !show);
  };

  async componentDidUpdate() {
    // จัดการสิทธิ์ก่อน (อาจ .remove() element ทำให้ layout เปลี่ยน) แล้วค่อย scroll
    this.permissionSetting();

    // มีเมนู 2 ชุด (มือถือ/เดสก์ท็อป) — เลือกเฉพาะ .active ที่มองเห็นจริง (ไม่ใช่ตัวที่ display:none)
    // และ scroll แค่ครั้งแรกที่เมนูโหลดเสร็จ ไม่งั้นจะดึง scroll ทุก re-render
    if (!this._scrolledToActive) {
      const active = [...document.querySelectorAll(".active")].find(
        (el) => el.offsetParent !== null,
      );
      if (active) {
        this._scrolledToActive = true;
        active.focus({ preventScroll: true });
        requestAnimationFrame(() =>
          active.scrollIntoView({ behavior: "smooth", block: "center" }),
        );
      }
    }
  }
  GetProfile = async () => {
    const result = await GET("admin/manage/users/profile");
    localStorage.setItem("scp-profile", JSON.stringify({ ...result.data }));
    return result.data;
  };
  GetActivity = async () => {
    let result = await GET("admin/manage/activity-settings", {data_search: "", page_size: 100, page: 0});
    let _menu = [
        { title: "เมนูหลัก" },
        { name: "แดชบอร์ด", icon: "\uf0ac", link: "/dashboard", role: "dashboard" },

        { title: "ข้อมูลผู้ใช้งาน" },
        { name: "เจ้าของแปลง", icon: "\uf007", link: "/land-owners", role: "land-owners" },
        { name: "พนักงาน", icon: "\uf508", link: "/users", role: "users" },
        { name: "ผู้รับเหมา", icon: "\uf82c", link: "/contractors", role: "contractors" },
        { name: "สิทธิ์การใช้งาน", icon: "\uf023", link: "/roles", role: "roles" },
        
        { title: "กิจกรรมส่งเสริม" }, 
        { name: "ข้อมูลแปลงอ้อย", icon: "\uf06c", link: "/plot-informations", role: "plot-informations" },
        ...(result.data ? result.data.map(item=>({ name: item.activity_name, icon: item.color, link: `/activity-trakings?uid=${item.uid}&activity=${encodeURIComponent(item.activity_name)}`, type: "activity-trakings", role: "activity-trakings" })) : []),
        
        { title: "การตั้งค่า" },
        { name: "ตั้งค่าระบบ", icon: "\uf013", link: "/system-settings", role: "system-settings" },
        { name: "รายการกิจกรรม", icon: "\uf78a", link: "/activitys", role: "activitys" },
        { name: "ฟิลด์", icon: "\uf022", link: "/fields", role: "fields" },
        { name: "อุปสรรคในแปลง", icon: "\uf05e", link: "/drawbacks", role: "drawbacks" },
        { name: "ประเภทอ้อย/สายพันธุ์", icon: "\uf7aa", link: "/cane-types", role: "cane-types" },
        { name: "ประเภทการซื้อ", icon: "\uf290", link: "/purchase-types", role: "purchase-types" },
        { name: "ประเภทการตัด", icon: "\uf6b2", link: "/cutting-types", role: "cutting-types" },
        { name: "ประเภทการไถ", icon: "\uf722", link: "/plowing-types", role: "plowing-types" },
        { name: "ประเภทการใส่ปุ๋ย", icon: "\uf4c1", link: "/fertilizing-types", role: "fertilizing-types" },
        { name: "ฉีดยากำจัดวัชพืช", icon: "\uf5bd", link: "/herbicide-types", role: "herbicide-types" },
        { name: "การเข้าตัด", icon: "\uf0c4", link: "/cutting-entry-types", role: "cutting-entry-types" },
        { name: "การส่งอ้อย", icon: "\uf48b", link: "/cane-delivery-types", role: "cane-delivery-types" },
        { name: "เลขโควต้า", icon: "\uf02b", link: "/quota-numbers", role: "quota-numbers" },
        { name: "ประเภทรถบรรทุก", icon: "\uf0d1", link: "/truck-types", role: "truck-types" },
        { name: "สถานะแปลง", icon: "\uf1fe", link: "/plot-status", role: "plot-status" },
        { name: "ประเภทแปลง", icon: "\uf57d", link: "/plot-types", role: "plot-types" },
        { name: "ประเภทดิน", icon: "\uf4d8", link: "/soil-types", role: "soil-types" },
        { name: "กลุ่มรถ", icon: "\uf48b", link: "/group-cars", role: "group-cars" },

        { title: "รายงาน" },
        { name: "🟢Trip Sheet", icon: "\uf48b", link: "/trip-sheets-report", role: "trip-sheets-report" },
        { name: "ประเมินผลผลิตอ้อย", icon: "\uf48b", link: "/yield-eval-report", role: "yield-eval-report" },
        { name: "การตัดอ้อย", icon: "\uf48b", link: "/cutting-report", role: "cutting-report" },
        { name: "🟡ผู้รับเหมา", icon: "\uf48b", link: "/contractor-report", role: "contractor-report" },
        { name: "ค่าตัดคีบ-อ้อยตามแปลง", icon: "\uf48b", link: "/cut-load-cost-report", role: "cut-load-cost-report" },
        { name: "ตันต่อแปลง", icon: "\uf48b", link: "/tons-plot-report", role: "tons-plot-report" },
        { name: "ประสิทธิภาพของผู้คุมตัด", icon: "\uf48b", link: "/supervisor-perf-report", role: "supervisor-perf-report" },
        { name: "🟢รายงานกิจกรรมผู้รับเหมา", icon: "\uf48b", link: "/contractor-activities-report", role: "contractor-activities-report" },
        { name: "🟢รายงานข้อมูลแปลงอ้อย", icon: "\uf48b", link: "/plot-data-report", role: "plot-data-report" },
        { name: "🟢รายงานคิวช่าง", icon: "\uf48b", link: "/technician-queue-report", role: "technician-queue-report" },

        { title: "อื่นๆ" },
        { name: "อัพโหลด ดาวน์โหลด", icon: "", link: "/kmz", role: "kmz" },
        { name: "ประวัติการเปลี่ยนแปลง (Log)", icon: "", link: "/audit-logs", role: "audit-logs" },
      ];
    localStorage.setItem("menu_list", JSON.stringify(_menu));
    return _menu;
  };

  filterMenu = (menu_list, user_profile) => {
    const perms = user_profile?.role?.permissions || [];
    perms.push("fields.read")
    return (
      menu_list
        ?.filter(
          (item) =>
            !item.link ||
            perms.includes(item.role + ".read") ||
            perms.includes(item.type + ".read"),
        )
        .reduce((acc, item) => {
          if (item.title && acc.at(-1)?.title) return acc;
          acc.push(item);
          return acc;
        }, [])
        .filter((_, i, arr) => !(i === arr.length - 1 && arr[i].title)) || []
    );
  };

  permissionSetting = () => {
    const { user_profile } = this.state;
    const role = new Set(user_profile?.role?.permissions || []);
    global.permission.forEach((perm) => {
      if (!role.has(perm)) {
        [...document.getElementsByClassName(perm)].forEach((el) => el.remove());
      }
    });
    this.toggleCreate(true);
  };

  componentMenu = () => {
    const classNameBTN =
      "btn btn-outline-success border-0 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-1 rounded-3";
    const classNameICON = "icon wpx-20 ms-1";
    const classNameCOLOR = "wpx-10 hpx-10 rounded-circle";
    const currentPath = `/${window.location.href.split("/").pop()}`;
    const linkItem = (href, icon, label, isActive) => (
      <a href={href} className={`${classNameBTN} ${isActive ? "active" : ""}`} style={{ borderRadius: 12 }}>
        {icon.includes("#")? (
          <div className="wpx-20 hpx-20 d-flex align-items-center justify-content-center ms-1">
          <span className={classNameCOLOR} style={{ backgroundColor: icon }}></span>
          </div>
        ): (
        <span className={classNameICON} style={{ borderRadius: 10 }}>{icon}</span>
        )}
        <div className="mx-2">{label}</div>
      </a>
    );

    const { array_link } = this.state;

    return (
      <div className="pb-5">
        {array_link.map((item, i) => {
          if (item.title)
            return (
              <div className="my-2 text-12" key={`title-${i}`}>
                <b>{item.title}</b>
              </div>
            );
          const params = [`type=${item.type}`]?.filter(Boolean).join("&");
          const href = `${item.link}${item.type ? (item.link.includes("?") ? "&" : "?") + params : ""}`;
          const isActive = href === currentPath;
          return linkItem( `${href}`, item.icon, item.name, isActive );
        })}
        <hr />
        <div className="d-block d-xl-none">
          <button
            className={`${classNameBTN} text-danger`}
            style={{ borderRadius: 16 }}
            onClick={async () => {
              this.Logout();
            }}
          >
            <span className={classNameICON} style={{ borderRadius: 12 }}>
              {"\uf2f5"}
            </span>
            <div className="mx-2">ออกจากระบบ</div>
          </button>
        </div>
      </div>
    );
  };

  Logout = async () => {
    if (
      await alert(
        "",
        "warning",
        "ยืนยัน",
        "ยืนยันการออกจากระบบใช่หรือไม่?",
        "ออกจากระบบ",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await GET("logout", null);
      if (result?.status === true) {
        localStorage.clear();
        window.location.href = "/";
      }
      loading(false);
    }
  };

  render() {
    const { user_profile } = this.state;
    return (
      <div className="hpx-50">
        <Navbar
          className="px-3 px-xl-4 bg-light position-fixed w-100 border-secondary-light"
          style={{ zIndex: 1020, border: "0", borderBottom: "1px solid" }}
          expand="xl"
        >
          <Navbar.Brand href={`/dashboard`} className="fw-bold text-dark">
            <div className="position-relative d-flex">
              <img
                alt="logo"
                src={LOGO}
                height={25}
                style={{ objectFit: "contain" }}
                className="pointer"
                onClick={() => {
                  window.location.href = `/dashboard`;
                }}
              />
              <div className="fw-bold text-20 d-flex">
                <span style={{ color: "#71A228" }}>CANE</span>
                <span style={{ color: "#2B6550" }}>PRO</span>
              </div>
              <span
                className="position-absolute"
                style={{ right: 2, bottom: -8, fontSize: 10, color: "#71A228" }}
              >
                {user_profile?.user_type?.replaceAll("_", "")} v{" "}
                {global.version}
              </span>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle
            className="border-0"
            aria-controls="basic-navbar-nav"
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="d-none d-xl-flex align-items-center">
                <div className="d-none d-xl-flex align-items-center text-start">
                  <span className="bg-warning text-dark me-1 wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center">
                    {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                  </span>
                  <div className="px-2">
                    <div className="text-14">
                      {user_profile?.full_name || "Username"}
                    </div>
                    <div
                      className="text-12 text-secondary"
                      style={{ marginTop: -2 }}
                    >
                      {user_profile?.user_type?.replaceAll("_", " ")}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="d-block d-xl-none mb-5 pt-4 overflow-scroll"
                style={{ height: "80vh" }}
              >
                {this.componentMenu()}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div
          className="position-fixed wpx-260 bg-light overflow-scroll d-none d-xl-block border-secondary-light"
          style={{
            zIndex: 1021,
            height: "100vh",
            border: "0",
            borderRight: "1px solid",
          }}
        >
          <div
            className="d-flex pt-3 position-fixed bg-light pb-4 px-3 wpx-260 border-secondary-light"
            style={{
              border: "0",
              borderBottom: "1px solid",
              borderRight: "1px solid",
            }}
          >
            <div className="position-relative d-flex">
              <img
                alt="logo"
                src={LOGO}
                height={25}
                style={{ objectFit: "contain" }}
                className="pointer"
                onClick={() => {
                  window.location.href = `/dashboard`;
                }}
              />

              <div className="fw-bold text-20 d-flex">
                <span style={{ color: "#71A228" }}>CANE</span>
                <span style={{ color: "#2B6550" }}>PRO</span>
              </div>
              <span
                className="position-absolute"
                style={{ right: 2, bottom: -8, fontSize: 10, color: "#71A228" }}
              >
                {user_profile?.user_type?.replaceAll("_", "")} v{" "}
                {global.version}
              </span>
            </div>
          </div>
          <div className="px-3 mb-5" style={{ marginTop: 70 }}>
            {this.componentMenu()}
          </div>
          <div
            className="d-flex pt-2 position-fixed bg-light pb-3 px-3 wpx-260 border-secondary-light"
            style={{
              bottom: 0,
              border: "0",
              borderRight: "1px solid",
              borderTop: "1px solid",
            }}
          >
            <div className="d-flex align-items-center text-start w-100">
              <span className="bg-warning text-dark me-1 wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center">
                {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
              </span>
              <div className="px-2 w-100">
                <div className="text-14">
                  {user_profile?.full_name || "Username"}
                </div>
                <div
                  className="text-12 text-secondary"
                  style={{ marginTop: -2 }}
                >
                  {user_profile?.email}
                </div>
              </div>
              <span
                className="icon p-2 pointer"
                onClick={() => {
                  this.Logout();
                }}
              >
                {"\uf08b"}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
